export const gbifMatchUrl = (species: string): string => `https://api.gbif.org/v1/species/match?name=${encodeURIComponent(species)}`

export const gbifSpeciesUrl = (key: number): string => `https://www.gbif.org/species/${key}`

/** The in-app page that looks a taxon name up on GBIF when opened, so GBIF is only called on click. */
export const gbifRedirectPath = (species: string): string => `/gbif/${encodeURIComponent(species)}`

export type GbifMatch = { matchType?: string; rank?: string; usageKey?: number; speciesKey?: number }

/**
 * The backbone key a GBIF name match resolved to, or null when it matched nothing or only a rank above the name
 * (a species GBIF lacks resolves to its genus as HIGHERRANK). A genus or family name matches at its own rank.
 */
export function gbifKeyFromMatch(match: GbifMatch): number | null {
  if (match.matchType === 'NONE' || match.matchType === 'HIGHERRANK') return null
  return match.speciesKey ?? match.usageKey ?? null
}
